module.exports = __webpack_public_path__ + "img/claim-icon.b2db5c99.svg";